<div class="p-grid">
    <div class="p-col-12">
        <h4>{{template.name}}</h4>
        <p-tag value="{{template.templateType.name}}"></p-tag>
    </div>
</div>
<p-tabView>
    <p-tabPanel header="Segments">
        <ng-container *ngTemplateOutlet="templateSegmentList"></ng-container>
    </p-tabPanel>
    <p-tabPanel header="Options">
        <ng-container *ngTemplateOutlet="templateOptions"></ng-container>
    </p-tabPanel>
    <p-tabPanel header="Notifications">
        <ng-container *ngTemplateOutlet="templateNotifications"></ng-container>
    </p-tabPanel>
    <p-tabPanel header="Alert Triggers">
        <ng-container *ngTemplateOutlet="templateTriggers"></ng-container>
    </p-tabPanel>
</p-tabView>

<ng-template #templateSegmentList>
    <ng-container *ngIf="log">
      <lb-template-editor [logTimeZone]="log.timeZone" [template]="template"></lb-template-editor>
    </ng-container>
</ng-template>

<ng-template #templateOptions>
    <div class="template-options p-mt-3">
        <div class="p-grid">
            <label class="p-col-6">
                Template Name
            </label>
            <div class="p-col-6">
                <lb-inplace-editor acceptLabel="Save"
                                   [acceptEnabled]="!!getValueAlias('name').value.trim().length"
                                   (onAccept)="saveValueAlias('name')"
                                   (onReject)="getValueAlias('name').discard()">
                    <ng-template pTemplate="display">
	                    <button [label]="template.name"
	                            class="p-button-text p-0"
	                            pButton></button>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <input type="text" [(ngModel)]="getValueAlias('name').value" pInputText>
                    </ng-template>
                </lb-inplace-editor>
            </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Allow Submit When Required Fields Missing
            </label>
            <div class="p-col-6">
                <p-inputSwitch [(ngModel)]="getValueAlias('allowSubmitIncomplete').value" (ngModelChange)="saveValueAlias('allowSubmitIncomplete')"></p-inputSwitch>
            </div>
        </div>
        <div *ngIf="templateType === TemplateTypes.INSPECTION" class="p-grid">
            <label class="p-col-6">
                Require Comment For Abnormal Values
            </label>
            <div class="p-col-6">
                <p-inputSwitch [(ngModel)]="getValueAlias('requireCommentOnAbnormal').value" (ngModelChange)="saveValueAlias('requireCommentOnAbnormal')"></p-inputSwitch>
            </div>
        </div>
        <div *ngIf="templateType === TemplateTypes.INSPECTION" class="p-grid">
            <label class="p-col-6">
                Notify Default Co-Creators
            </label>
            <div class="p-col-6">
                <p-inputSwitch [(ngModel)]="getValueAlias('notifyDefaultCoCreators').value" (ngModelChange)="saveValueAlias('notifyDefaultCoCreators')"></p-inputSwitch>
            </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Turnover
            </label>
            <div class="p-col-6">
                <p-inputSwitch [(ngModel)]="getValueAlias('turnover').value" (ngModelChange)="saveValueAlias('turnover')"></p-inputSwitch>
            </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Carry Forward
            </label>
            <div class="p-col-6">
                <p-inputSwitch [(ngModel)]="getValueAlias('carryForward').value" (ngModelChange)="saveValueAlias('carryForward')"></p-inputSwitch>
            </div>
        </div>
        <div *ngIf="template.carryForward" class="p-grid">
            <label class="p-col-6">
                Carry Forward Days
            </label>
            <div class="p-col-6">
                <lb-inplace-editor acceptLabel="Save"
                                   (onAccept)="saveValueAlias('endCarryForwardDays')"
                                   (onReject)="getValueAlias('endCarryForwardDays').discard()">
                    <ng-template pTemplate="display">
	                    <button [label]="template.endCarryForwardDays == undefined ? 'No end time' : template.endCarryForwardDays == 0 ? 'End of same day' : template.endCarryForwardDays.toString()"
	                            class="p-button-text p-0"
	                            pButton></button>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div *ngVar="getEndCarryForwardDaysSetting() as endCarryForwardDays">
                          <div class="p-field-radiobutton">
                              <p-radioButton label="No end time" value="None" name="endCarryForwardDays" [(ngModel)]="endCarryForwardDays.value"></p-radioButton>
                          </div>
                          <div class="p-field-radiobutton">
                              <p-radioButton label="End of same day" value="End of Day" name="endCarryForwardDays" [(ngModel)]="endCarryForwardDays.value"></p-radioButton>
                          </div>
                          <div class="p-field-radiobutton">
                              <p-radioButton label="Other" value="Specific" name="endCarryForwardDays" [(ngModel)]="endCarryForwardDays.value"></p-radioButton>
                          </div>
                          <div [hidden]="endCarryForwardDays.value != 'Specific'">
                              <p-inputNumber [min]="1" [(ngModel)]="getValueAlias('endCarryForwardDays').value"></p-inputNumber>
                          </div>
                        </div>
                    </ng-template>
                </lb-inplace-editor>
            </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Maximum Note Height
            </label>
            <div class="p-col-6">
                <lb-inplace-editor acceptLabel="Save"
                                   (onAccept)="saveValueAlias('maxNoteHeight')"
                                   (onReject)="getValueAlias('maxNoteHeight').discard()">
                    <ng-template pTemplate="display">
	                    <button
		                    [label]="template.maxNoteHeight == null ? 'Log Default' : template.maxNoteHeight == 0 ? 'Unlimited' : template.maxNoteHeight.toString()"
		                    class="p-button-text p-0"
		                    pButton></button>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div *ngVar="getMaxNoteHeightSetting() as maxNoteHeight">
                          <div class="p-field-radiobutton">
                              <p-radioButton name="maxNoteHeight" value="Default" label="Log Default" [(ngModel)]="maxNoteHeight.value"></p-radioButton>
                          </div>
                          <div class="p-field-radiobutton">
                              <p-radioButton name="maxNoteHeight" value="Unlimited" label="Unlimited Height" [(ngModel)]="maxNoteHeight.value"></p-radioButton>
                          </div>
                          <div class="p-field-radiobutton">
                              <p-radioButton name="maxNoteHeight" value="Specific" label="Other" [(ngModel)]="maxNoteHeight.value"></p-radioButton>
                          </div>
                          <div [hidden]="maxNoteHeight.value != 'Specific'">
                              <p-inputNumber [min]="1" placeholder="Number of lines to show" [(ngModel)]="getValueAlias('maxNoteHeight').value"></p-inputNumber>
                          </div>
                        </div>
                    </ng-template>
                </lb-inplace-editor>

            </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Maximum Comments
            </label>
            <div class="p-col-6">
                <lb-inplace-editor acceptLabel="Save"
                                   (onAccept)="saveValueAlias('commentsToShow')"
                                   (onReject)="getValueAlias('commentsToShow').discard()">
                    <ng-template pTemplate="display">
	                    <button
		                    [label]="template.commentsToShow == null ? 'Log Default' : template.commentsToShow == 0 ? 'All Comments' : template.commentsToShow.toString()"
		                    class="p-button-text p-0"
		                    pButton></button>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div *ngVar="getCommentsToShowSetting() as commentsToShow">
                            <div class="p-field-radiobutton">
                                <p-radioButton name="commentsToShow" label="Log Default" [value]="'Default'" [(ngModel)]="commentsToShow.value"></p-radioButton>
                            </div>
                            <div class="p-field-radiobutton">
                                <p-radioButton name="commentsToShow" label="All Comments" [value]="'All'" [(ngModel)]="commentsToShow.value"></p-radioButton>
                            </div>
                            <div class="p-field-radiobutton">
                                <p-radioButton name="commentsToShow" label="Other" [value]="'Specific'" [(ngModel)]="commentsToShow.value"></p-radioButton>
                            </div>
                            <div [hidden]="commentsToShow.value != 'Specific'">
                                <p-inputNumber [min]="1" placeholder="Comments to Show" [(ngModel)]="getValueAlias('commentsToShow').value"></p-inputNumber>
                            </div>
                        </div>
                    </ng-template>
                </lb-inplace-editor>
            </div>
        </div>
        <div *ngIf="templateType === TemplateTypes.INSPECTION" class="p-grid">
            <label class="p-col-6">
                Default Co-Creators
            </label>
            <div class="p-col-6">
                <div>
                    <lb-inplace-editor (onActivate)="startEditingUsers()" acceptLabel="Save" (onAccept)="saveDefaultCoCreators(template.defaultCoCreators, coCreators)">
                        <ng-template pTemplate="display">
	                        <button
		                        class="p-button-text p-0"
		                        [label]="template.defaultCoCreators && template.defaultCoCreators.length ? template.defaultCoCreators.length + ' users' : 'None'"
		                        pButton></button>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <lb-user-list-selector [logId]="template.logId" type="logUser" [(ngModel)]="coCreators"></lb-user-list-selector>
                        </ng-template>
                    </lb-inplace-editor>
                </div>
            </div>
        </div>

        <p-divider></p-divider>
        <h4>Access Controls</h4>
        <div class="p-grid">
          <div class="p-col-6">
            <label>Web</label>
          </div>
          <div class="p-col-6">
            <p-inputSwitch [(ngModel)]="getValueAlias('enterNotes').value" (ngModelChange)="saveValueAlias('enterNotes')"></p-inputSwitch>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-6">
            <label>Evident</label>
          </div>
          <div class="p-col-6">
            <p-inputSwitch [(ngModel)]="getValueAlias('evident').value" (ngModelChange)="saveValueAlias('evident')"></p-inputSwitch>
          </div>
        </div>
        <div class="p-grid">
            <label class="p-col-6">
                Access
            </label>
            <div class="p-col-6">
                <div>
                    <lb-inplace-editor acceptLabel="Save" (onReject)="getAccessAlias().discard()" (onAccept)="saveAccessValue()">
                        <ng-template pTemplate="display">
	                        <button [label]="template.allowAllUsers ? 'All Users' : (template.allowedUsers.length > 0) ? (template.allowedUsers.length + ' users') : 'None'"
	                                class="p-button-text p-0"
	                                pButton></button>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <lb-all-user-selector [logId]="template.logId" [(ngModel)]="getAccessAlias().value"></lb-all-user-selector>
                        </ng-template>
                    </lb-inplace-editor>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #templateNotifications>
    <ng-container *ngIf="template.templateType.id === 2 || !hasSubTemplates">
        <ng-container *ngIf="!log || !alertConfig">
            <lb-loading-indicator label="Loading Notification Settings"></lb-loading-indicator>
        </ng-container>
        <template-alert-container *ngIf="log && alertConfig" [(selectedLog)]="log!" [template]="template"
                                  [draftSaveMessage]="alertConfig.draftSaveMessage"
                                  [navigateHaltMessage]="alertConfig.navigateHaltMessage"
                                  [publishSaveMessage]="alertConfig.publishSaveMessage"
                                  [config]="alertConfig.config" [singleEditAlert]="alertConfig.getAlert">
        </template-alert-container>
    </ng-container>
    <ng-container *ngIf="template.templateType.id === 1 && hasSubTemplates">
        <div class="p-d-flex p-jc-center">
            <label class="p-text-center">
                Operational templates with subtemplates do not support Notifications.<br>
                <br>
                To be notified of these types of Notes, Alerts and Alert Triggers must be configured.<br>
            </label>
        </div>
    </ng-container>
</ng-template>

<ng-template #templateTriggers>
    <div class="p-mt-3">
        <ng-container *ngIf="log">
            <div class="p-grid">
                <div class="p-col-12">
                    <lb-alert-triggers [log]="log" [template]="template"></lb-alert-triggers>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!log">
            <lb-loading-indicator label="Loading Alert Triggers"></lb-loading-indicator>
        </ng-container>
    </div>
</ng-template>
